import { User } from 'lucide-react';
import { Avatar, AvatarImage, AvatarFallback } from '@hqo/ui-atoms';
import { usePhotoByUuid } from 'hooks/use-photo-by-uuid.hook';

interface VisitorAvatarProps {
  firstName?: string;
  lastName?: string;
  imageUrl?: string;
  photoUuid?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

const textSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
};

const iconSizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

export const VisitorAvatar = ({
  firstName,
  lastName,
  imageUrl,
  photoUuid,
  size = 'sm',
  className = '',
}: VisitorAvatarProps): JSX.Element => {
  const { photoUrl: fetchedPhotoUrl } = usePhotoByUuid(photoUuid && !imageUrl ? photoUuid : null);

  const displayUrl = imageUrl || fetchedPhotoUrl;
  const initials = `${firstName?.[0]?.toUpperCase() || ''}${lastName?.[0]?.toUpperCase() || ''}`;

  return (
    <Avatar className={`${sizeClasses[size]} flex-shrink-0 ${className}`}>
      {displayUrl ? <AvatarImage src={displayUrl} alt={`${firstName} ${lastName}`} /> : null}
      <AvatarFallback className={`${textSizeClasses[size]} font-medium bg-primary/10 text-primary`}>
        {initials || <User className={iconSizeClasses[size]} />}
      </AvatarFallback>
    </Avatar>
  );
};
